export default __webpack_public_path__ + "static/media/logo-white.75edfae5.svg";